const translations = {
  "en": {
    "Check your email": "Check your email",
    "Invalid verification code": "Invalid verification code",
    "We sent a 6-digit code to": "We sent a 6-digit code to"
  },
  "zh-tw": {
    "Check your email": "檢查你的電子郵件",
    "Invalid verification code": "驗證碼錯誤",
    "We sent a 6-digit code to": "我們已傳送一組 6 位數驗證碼至"
  }
};

export default translations;
